import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

export function getUpdateDealer(values) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.post(INSPECTION_URL + 'update_dealer/', values)
          .then((res) => {
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
  }